import { joinStepApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Badge } from 'primereact/badge'
import { Card } from 'primereact/card'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function UsageSteps(): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Confirm' })
  const context = useWebAppContext()
  const joinStepsResponse = joinStepApi.useJoinStepList(
    { pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId } },
    { meta: { context }, throwOnError: true },
  )

  const cols = joinStepsResponse.data?.length
  // const context = useWebAppContext()
  return (
    <>
      <div className='m-12 text-center text-[28px]'>{t('bannerStepsTitle')}</div>
      <div className={`lg:grid-cols-${cols} grid gap-1 lg:gap-4`}>
        {joinStepsResponse.data?.map((item, index) => (
          <div key={index} className='flex'>
            <Card
              className='flex-grow bg-[var(--card-background)]'
              header={
                <div className='mt-[-25px] text-center'>
                  <Badge value={item.id} size='xlarge'></Badge>
                </div>
              }
            >
              <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </Card>
          </div>
        ))}
      </div>
    </>
  )
}
